import {
  LOAD_PRODUCTS,
  LOAD_SUBGROUPS,
  PRODUCTS_LOADED,
  RESET_PRODUCTS,
  RESET_SUBGROUPS,
  SUBGROUPS_LOADED,
  SUBGROUPS_SYNC_FAILED,
  SYNC_FAILED,
} from './actionTypes';
import type { ISeedProductsState, ISeedProductSubgroup } from './types';

const countSubGroupsInSeedProducts = (
  subGroups: ISeedProductSubgroup[],
  products: ISeedProductsState['products'],
): ISeedProductSubgroup[] => {
  if (!products || products.length === 0) return subGroups;

  const productsCountBySubGroup = products.reduce((res, product) => {
    res[product.subGroupReference || ''] =
      product.subGroupReference && product.subGroupReference in res
        ? res[product.subGroupReference] + 1
        : 1;

    return res;
  }, {});

  return subGroups.map((subGroup) => ({
    ...subGroup,
    productsCount: productsCountBySubGroup[subGroup.subGroupReference] || 0,
  }));
};

export const initialState: ISeedProductsState = {
  error: null,
  products: [],
  loading: false,
  loaded: false,
  subGroups: {
    error: null,
    loaded: false,
    data: [],
    loading: false,
  },
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, error: null, loading: true };
    case PRODUCTS_LOADED:
      return {
        ...state,
        error: null,
        products: action.payload.data,
        subGroups: {
          ...state.subGroups,
          data: countSubGroupsInSeedProducts(state.subGroups.data, action.payload.data),
        },
        loading: false,
        loaded: true,
      };

    case RESET_PRODUCTS:
      return { ...initialState, subGroups: state.subGroups };
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    case LOAD_SUBGROUPS:
      return { ...state, subGroups: { ...state.subGroups, error: null, loading: true } };
    case SUBGROUPS_LOADED:
      return {
        ...state,
        subGroups: {
          error: null,
          data: countSubGroupsInSeedProducts(action.payload, state.products),
          loading: false,
          loaded: true,
        },
      };

    case RESET_SUBGROUPS:
      return { ...state, subGroups: initialState.subGroups };
    case SUBGROUPS_SYNC_FAILED:
      return {
        ...state,
        subGroups: {
          ...state.subGroups,
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};
